import * as firestore from 'firebase/firestore';
import { DateTime } from 'luxon';
import { Notification } from '../types/Notification';

export default {
  toFirestore(notification: Notification): firestore.DocumentData {
    return notification;
  },
  fromFirestore(
    snapshot: firestore.QueryDocumentSnapshot
  ): Notification {
    const data = snapshot.data()!;
    return {
      id: data.id,
      title: data.title,
      body: data.body,
      status: data.status,
      pathToDocument: data.pathToDocument,
      dateCreated: data.dateCreated,
      dateRead: data.dateRead,
      lastUpdate: DateTime.fromJSDate((data.lastUpdate as firestore.Timestamp).toDate()).toISO()
    };
  }
};
